var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15V9.99998M10 15V10.8333M12.5 15V8.33331M14.1667 2.49998H17.5V19.1666H2.5V2.49998H5.83333M5.83333 0.833313H14.1667V4.16665H5.83333V0.833313Z",
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCard);
export default __webpack_public_path__ + "static/media/score-card.2b52f61d56bdacdff12b433a61fc6dff.svg";
export { ForwardRef as ReactComponent };